import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import calendarSaga from "./calendar/saga"
import dashboardSaga from "./dashboard/saga";
import bookingsSaga from "./bookings/saga";
import driversSaga from "./drivers/saga";
import customersSaga from "./customers/saga";
import materialsSaga from "./materials/saga";
import refferalsSaga from "./refferals/saga";
import contactUsSaga from "./contact-us/saga";
import discountsSaga from "./discounts/saga";
import promotionsSaga from "./promotions/saga";
import faqsSaga from "./faqs/saga";
import promoCodesSaga from "./promo-codes/saga";
import vehiclesSaga from "./vehicles/saga";
import garagesSaga from "./garages/saga";
import vehiclesCategoriesSaga from "./vehicles-categories/saga";
import vehiclesBodyTypesSaga from "./vehicles-bodytypes/saga";
import driversDocumentsTypesSaga from "./drivers-documents-types/saga";
import driversDocumentsSaga from "./drivers-documents/saga";
import vehiclesDocumentsTypesSaga from "./vehicles-documents-types/saga";
import vehiclesDocumentsSaga from "./vehicles-documents/saga";
import AneesVouchersSaga from "./anees-vouchers/saga";

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    fork(calendarSaga),
    dashboardSaga(),
    bookingsSaga(),
    driversSaga(),
    garagesSaga(),
    customersSaga(),
    materialsSaga(),
    refferalsSaga(),
    promotionsSaga(),
    discountsSaga(),
    contactUsSaga(),
    faqsSaga(),
    promoCodesSaga(),
    vehiclesBodyTypesSaga(),
    vehiclesSaga(),
    vehiclesCategoriesSaga(),
    driversDocumentsTypesSaga(),
    driversDocumentsSaga(),
    vehiclesDocumentsTypesSaga(),
    vehiclesDocumentsSaga(),
    AneesVouchersSaga()
  ])
}
